import { AnchorManagementPage } from '@/pages/anchor-management/assortment'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_app/p/anchor-management/assortment')({
	component: AnchorManagementPage,
})
